import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { type AppViewNavigation } from '@/components/templates/AppView'

export const useMapPendingTeamStatusFilterItems = (): Pick<AppViewNavigation, 'mapPendingTeamStatusFilterItems'> => {
  const intl = useIntl()

  return useMemo(
    () => ({
      mapPendingTeamStatusFilterItems: [
        {
          id: 'available',
          label: intl.formatMessage({ id: 'teamStatus.available' }),
          default: true,
        },
        {
          id: 'paused',
          label: intl.formatMessage({ id: 'teamStatus.paused' }),
          default: false,
        },
        {
          id: 'returning',
          label: intl.formatMessage({ id: 'teamStatus.returning' }),
          default: false,
        },
      ],
    }),
    [intl]
  )
}
